enum AttachmentStatusEnum {
    Added = 0,
    Deleted = 1,
}
export default AttachmentStatusEnum;
